import { Tooltip } from 'antd';
import React, { useMemo } from 'react';
import UserProfilePopover from '../../../../src-new/components/popovers/UserProfilePopover';
import { getWorkspacePalette } from '../../../../js/helper';

const USER_COLORS_SET = new Map();

const UserAvatar = ({
  alt,
  classNames,
  fullName,
  userId,
  onClick,
  src,
  styles,
  user,
  tooltip
}) => {
  const isDefaultAvatar = useMemo(
    () => !src || src?.includes('pmc/public/users/global/no_avi.png'),
    [src],
  );

  const userInitials = useMemo(() => {
    if (!fullName) return;
    const splittedName = fullName?.split(' ');
    const result =
      splittedName.length > 1
        ? `${splittedName[0].slice(0, 1)}${splittedName[splittedName.length - 1].slice(0, 1)}`
        : splittedName[0].slice(0, 1);
    return result;
  }, [fullName]);

  const defaultAvatarPalette = useMemo(() => {
    if (!fullName) return null;
    return getWorkspacePalette(fullName);
  }, [fullName]);

  // For small avatars the translucent palette bg looks washed out — use an opaque version
  const opaqueAvatarBg = useMemo(() => {
    if (!defaultAvatarPalette) return null;
    // Replace the rgba opacity with 1 for a solid background
    return defaultAvatarPalette.bg.replace(/rgba\((\d+),(\d+),(\d+),[^)]+\)/, 'rgba($1,$2,$3,1)');
  }, [defaultAvatarPalette]);

  const defaultAvatarStyles = useMemo(
    () => ({
      ...styles,
      background: opaqueAvatarBg,
      color: 'white',
    }),
    [opaqueAvatarBg, styles],
  );


  const avatarRenderer = () => {
    // No src and no name yet — pulse skeleton to avoid broken-image flash
    if (!src && !userInitials) {
      return (
        <div
          className="rounded-full bg-gray-200 animate-pulse flex-shrink-0"
          onClick={onClick}
          style={styles}
        />
      );
    }

    // No real src (null / placeholder) but we have a name — show initials immediately
    if (!src || isDefaultAvatar) {
      return (
        <div
          className={`d-flex align-center justify-center default-user-avatar ${classNames || ''}`}
          onClick={onClick}
          style={defaultAvatarStyles}
        >
          <div className="default-user-avatar-initials">{userInitials}</div>
        </div>
      );
    }

    return (
      <img
        alt={alt || `${fullName} avatar`}
        className={`rounded-full object-cover flex-shrink-0 ${classNames || ''}`}
        onClick={onClick}
        src={src}
        style={{ ...styles, border: 'none' }}
        referrerPolicy="no-referrer"
      />
    );
  };

  if (!user) {
    return <Tooltip title={fullName}>{avatarRenderer()}</Tooltip>;
  }

  
  return (
    <UserProfilePopover member={user}>
      {avatarRenderer()}
    </UserProfilePopover>
  );
};

export default UserAvatar;
